import AuthRoutesHandler from "../components/RoutesHandler/AuthRoutesHandler";
import { Outlet } from "react-router-dom";

export const AuthProtected = () => {
  return (
    <AuthRoutesHandler>
      <Outlet />
    </AuthRoutesHandler>
  );
};
